import { createRouter, createWebHistory } from 'vue-router'
import CallView from '../views/CallView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'call',
      component: CallView,
    },
    // {
    //   path: '/history',
    //   name: 'history',
    //   component: () => import('../views/HistoryView.vue'),
    // },
  ],
})

export default router
